import React from 'react';
import {Link} from 'react-router-dom';
import '../style/main.scss';

class Navbar extends React.Component{

    state = {
        toggle: false
    }

    menuToggle = () => {
        this.setState({
            toggle: !this.state.toggle
        })
    }
    
    render(){
        
        const {toggle} = this.state;
        
        return(
            <header>
                <div className='logo'>
                    <h3><a href='/'>Startup Learning</a></h3>
                </div>
                <ul className={toggle ? "toggle" : "not-toggle"}>
                    <li><Link to='/'>Home</Link></li>
                    <li><Link to='/resource'>Resources</Link></li>
                    <li><Link to='/contact'>Contact</Link></li>
                    <li className='close' onClick={this.menuToggle}>X</li>
                </ul>
                <div className='menu' onClick={this.menuToggle}>Menu</div>
            </header>
        )
    }
}

export default Navbar;